import React, { useMemo, useState } from 'react';
import CustomSideNav from './sidenav';
import useStore from '../store/zustandstore';
import { useLocation } from 'react-router-dom';

const SideNavLayout = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const isSidenav = useStore((state) => state.isSidenav);
  const location = useLocation();
  const contentStyle = {
    marginLeft: isCollapsed ? 68 : 240,
    transition: 'margin-left 200ms ease',
    minHeight: '100vh',
  };
  const queryParams = useMemo(() => new URLSearchParams(window.location.search), []);
  const allowToken = queryParams.get('allowtoken'); // special flow token
  const sidebarParam = queryParams.get('sb'); // optional codes or SD
   let showSidebar = isSidenav;
    if (allowToken) {
    // special flow: check sidebar param
    if (sidebarParam) {
      showSidebar = true; 
    } else {
      showSidebar =false; 
    }
  } else {
    // normal flow: show sidebar only if isSidenav
    showSidebar = isSidenav;
  }
  if (!showSidebar) {
    return children;
  }
  
 const bgColor =
    location.pathname === '/tasks'
      ? 'bg-[#f1f1f1]'
      : 'bg-[#FAFAF9]';
  return (
    <div className="flex">
      <CustomSideNav isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
      <div
             className={`flex-grow p-4 min-h-screen ${bgColor}`}
        style={contentStyle}
      >
        {children}
      </div>
    </div>
  );
};

export default SideNavLayout;
